<script>
import Required from "@/components/template/Required";
export default {
  name: "BaseContent",
  components: { Required },
};
</script>
<style lang="scss" scoped></style>
